import { TFunction } from 'i18next';
import * as Yup from 'yup';
export const validationSchema = (t: TFunction) =>
  Yup.object({
    promoName: Yup.string().required(t('valid_err_promotion_name')),
    branch: Yup.array()
      .of(Yup.number().required(t('valid_err_branch_number')))
      .min(1, t('valid_err_branch'))
      .required(t('valid_err_branch')),
    promoType: Yup.string().required(t('valid_err_promotion_type')),
    notLimitDate: Yup.string(),
    ConditionType: Yup.string().required(t('valid_err_required')),
    DiscountType: Yup.string().required(t('valid_err_required')),
    promoPeriod: Yup.object().shape({
      dateRange: Yup.object().shape({
        start: Yup.string().when('$notLimitDate', {
          is: '0',
          then: (schema) => schema.required(t('valid_err_date')),
          otherwise: (schema) => schema.notRequired(),
        }),
        end: Yup.string().when('$notLimitDate', {
          is: '0',
          then: (schema) => schema.required(t('valid_err_date')),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
      timeRange: Yup.object().shape({
        start: Yup.string().when('$notLimitDate', {
          is: '0',
          then: (schema) => schema.required(t('valid_err_time')),
          otherwise: (schema) => schema.notRequired(),
        }),
        end: Yup.string().when('$notLimitDate', {
          is: '0',
          then: (schema) => schema.required(t('valid_err_time')),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
      days: Yup.object()
        .shape({
          sun: Yup.boolean(),
          mon: Yup.boolean(),
          tue: Yup.boolean(),
          wed: Yup.boolean(),
          thu: Yup.boolean(),
          fri: Yup.boolean(),
          sat: Yup.boolean(),
        })
        .when('$notLimitDate', {
          is: '0',
          then: (schema) =>
            schema.test('at-least-one-day', t('valid_err_day'), (value) =>
              Object.values(value || {}).some((day) => day === true)
            ),
          otherwise: (schema) => schema.notRequired(),
        }),
    }),

    promoProducts: Yup.object().shape({
      lists: Yup.array()
        .of(Yup.string())
        .when('$ConditionType', {
          is: '3',
          then: (schema) => schema.notRequired(),

          otherwise: (schema) =>
            schema.min(1, t('PleaseSelectAtLeastOne')).required(),
        }),
    }),

    promoDiscount: Yup.array()
      .of(
        Yup.object().shape({
          qty: Yup.string().when('$promoType', {
            is: (promoType: string) => promoType !== '4',
            then: (schema) => schema.required(t('valid_err_required')),
            otherwise: (schema) => schema.notRequired(),
          }),
          discount: Yup.string().when('$promoType', {
            is: (promoType: string) => promoType !== '4',
            then: (schema) => schema.required(t('valid_err_required')),
            otherwise: (schema) => schema.notRequired(),
          }),
        })
      )
      .when('$promoType', {
        is: '4',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required(t('valid_err_required')),
      }),

    promoFreeGift: Yup.object().shape({
      conditionType: Yup.string().when('$promoType', {
        is: '4',
        then: (schema) => schema.required(t('valid_err_required')),
        otherwise: (schema) => schema.notRequired(),
      }),
      thresholdValue: Yup.string().when('$promoType', {
        is: '4',
        then: (schema) => schema.required(t('valid_err_required')),
        otherwise: (schema) => schema.notRequired(),
      }),
      freeType: Yup.string().when('$promoType', {
        is: '4',
        then: (schema) => schema.required(t('valid_err_required')),
        otherwise: (schema) => schema.notRequired(),
      }),
      freeQty: Yup.string().when('$promoType', {
        is: '4',
        then: (schema) => schema.required(t('valid_err_required')),
        otherwise: (schema) => schema.notRequired(),
      }),
      freeList: Yup.array().when('$promoType', {
        is: '4',
        then: (schema) => schema.min(1, t('PleaseSelectAtLeastOne')).required(),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    usage_limit: Yup.string().required(t('valid_err_required')),
    isActive: Yup.string(),
  });
export type PromoValidationSchemaType = ReturnType<typeof validationSchema>;
